import React, { useEffect, useState } from "react";
import Hero from "../Hero";
import VendorSlider from "../VendorSlider";
import SearchForParts from "../SearchForParts";
import FindProductsByCategory from "../FindProductsByCategory";
import DealOfTheWeek from "../DealOfTheWeek/DealOfTheWeek";
import WeeklySpecials from "../WeeklySpecials/WeeklySpecials";

import { useNavigate } from "react-router-dom";
import PromoBanner from "../PromoBanner";

const Home = ({
  customerCategory,
  vendors,
  categoriesAndTypes,
  pageContent,
}) => {
  const navigate = useNavigate();

  return (
    <div>
      <Hero />
      <SearchForParts />
      <PromoBanner />
      <VendorSlider vendors={vendors} />
      <FindProductsByCategory
        categoriesAndTypes={categoriesAndTypes}
        customerCategory={customerCategory}
      />
      {/* <DealOfTheWeek />
      <WeeklySpecials
        categoriesAndTypes={categoriesAndTypes}
        customerCategory={customerCategory}
      /> */}
    </div>
  );
};
export default Home;
